import {combineReducers} from 'redux'
import {handleActions} from 'redux-actions';
import {
    loadSuccess,
    loadWaiting,
    selectTour,
    setEmail,
    setName,
    setPhone,
    setTours,
    submitFailure,
    submitSuccess,
    submitWaiting
} from "./actions";

const listing = handleActions({
    [setTours]: (state, {payload}) => payload
}, []);

const registration = handleActions({
    [selectTour]: (state, {payload}) => ({...state, tour: payload}),
    [setName]:    (state, {payload}) => ({...state, name: payload}),
    [setPhone]:   (state, {payload}) => ({...state, phone: payload}),
    [setEmail]:   (state, {payload}) => ({...state, email: payload})
}, {
    name:  '',
    phone: '',
    email: ''
});

const load = handleActions({
    [loadWaiting]: () => ({waiting: true}),
    [loadSuccess]: () => ({success: true}),
}, {});

const submit = handleActions({
    [submitWaiting]: () => ({waiting: true}),
    [submitSuccess]: () => ({success: true}),
    [submitFailure]: () => ({failure: true})
}, {});

export default combineReducers({load, listing, registration, submit})




// WEBPACK FOOTER //
// ./src/app/tours/reducers.js